module.exports = __webpack_public_path__ + "img/armaBoca7.c66a77f7.jpg";